import React from 'react';
import styles from './ValuePropsBox.module.scss';
import classNames from 'classnames';

export interface ValueProp {
  icon?: React.ReactNode;
  text: React.ReactElement | string;
  fade?: boolean; // Makes value prop light gray
  compact?: boolean;
}

interface ValuePropsBoxProps {
  className?: string;
  header?: React.ReactElement;
  columns?: number;
  valueProps: ValueProp[];
  compact?: boolean;
  direction?: 'row' | 'column';
}

// To accommodate different lengths of value props, dynamically calculate the number of rows the
// value prop box should have, when the number of columns is 2.
function getGridTemplateRowsValue(valueProps: ValueProp[], columns = 2) {
  if (!valueProps.length || columns === 1) {
    return '';
  }

  const numRows = Math.round(valueProps.length / columns);
  return '1fr '.repeat(numRows);
}

export default function ValuePropsBox({
  className,
  header,
  valueProps,
  columns = 2,
  compact = false,
  direction = 'row',
}: ValuePropsBoxProps) {
  return (
    <div
      className={classNames(styles.container, className, { [styles.compactContainer]: compact })}
      style={{ gridTemplateRows: getGridTemplateRowsValue(valueProps, columns) }}
    >
      {header}
      {valueProps.map((valueProp, i) => (
        <div className={classNames(styles.valueProp, { [styles.valuePropColumn]: direction === 'column' })} key={i}>
          {valueProp.icon && (
            <div className={classNames(styles.icon, { [styles.fade]: valueProp.fade })}>{valueProp.icon}</div>
          )}
          <div className={classNames(styles.text, { [styles.fade]: valueProp.fade })}>{valueProp.text}</div>
        </div>
      ))}
    </div>
  );
}
